module.exports = __webpack_public_path__ + "img/microneedling.056364b6.jpg";